import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Transition from 'react-transition-group/Transition';

import './PageShell.css';

const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
}

const transitionStyles = {
  entering: { opacity: 0 },
  entered:  { opacity: 1 },
};




const PageShell = Page => {
  console.log(Page);
  return props =>
    <div className="PageShell">
      <ReactCSSTransitionGroup
        transitionAppear={true}
        transitionAppearTimeout={600}
        transitionEnterTimeout={600}
        transitionLeaveTimeout={200}
        transitionName={'FadeIn'}
      >
        <Page {...props} />
      </ReactCSSTransitionGroup>
    </div>
};

export default PageShell;



// WEBPACK FOOTER //
// ./src/components/Page/PageShell/PageShell.js